import React from 'react';
import { Form as AntForm } from 'antd-v5';
import './style.less';
function Form(props) {
  const { form, className, colon = false, ...nativeProps } = props;

  return <AntForm form={form} className={`ui-form ${className}`} colon={colon} {...nativeProps} />;
}
Form.useForm = AntForm.useForm;
Form.Item = AntForm.Item;
Form.List = AntForm.List;
Form.ErrorList = AntForm.ErrorList;
Form.Provider = AntForm.Provider;
Form.useFormContext = AntForm.useFormContext;
Form.useFormInstance = AntForm.useFormInstance;
Form.useFormList = AntForm.useFormList;
Form.useFormInstance = AntForm.useFormInstance;
export default Form;
